import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {AnchorButton, Button, Menu} from '@blueprintjs/core'
import { Popover2 } from '@api'
import {StoresInstanceContext, useVipLocalStore, VipLocalStore, WorkspaceChooser, WorkspaceChooserMenuItems} from '@modules'
import {StoresInstance, WorkspaceConfig} from '@stores'
import * as css from './NewMaximizedTabToolbarDropdown.css'

/// region Store

export class NewMaximizedTabToolbarDropdownStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const toDispose: Array<IDisposer> = []

    return () => toDispose.forEach(d => d())
  }

  @observable foo = false

  @computed get bar() { return null }



  @computed get disabled() {
    return this.stores.flexLayout.model != null
  }
}

export const NewMaximizedTabToolbarDropdownStoreContext = React.createContext<NewMaximizedTabToolbarDropdownStore>(null)
export const useNewMaximizedTabToolbarDropdownStore = () => React.useContext(NewMaximizedTabToolbarDropdownStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const NewMaximizedTabToolbarDropdown = observer<MyProps>(function NewMaximizedTabToolbarDropdown({className, ...props}) {
  const obsProps = useAsObservableSource({props}),
    store = useVipLocalStore((stores) => new NewMaximizedTabToolbarDropdownStore(stores, obsProps)),
    {flexLayout: {create: {onNewWorkspaceItem}, isMaximized}, disabled} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <NewMaximizedTabToolbarDropdownStoreContext.Provider value={store}>
      <Popover2 className={classNames(css.root, className)}
                interactionKind='hover'
                minimal
                disabled={disabled}
                position='bottom-left'
                content={
                  <Menu className={css.workspaceTabDropdownMenu}>
            <WorkspaceChooserMenuItems onClickWorkspaceItem={onNewWorkspaceItem}/>
          </Menu>}>
        {!isMaximized && <Button disabled={disabled} minimal className={css.button} icon='document' rightIcon='caret-down' text='New Report Item...' />}
      </Popover2>
    </NewMaximizedTabToolbarDropdownStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/NewMaximizedTabToolbarDropdown.tsx